import React from "react";

export const RenewablePower = [
  <div className="slideContainer slide_solidColour">
    <div className="colLeft col50">
      <h4 className="slideTitle">All-in-one renewable energy solution</h4>
      <p>
        With our renewable power offering, we help customers reduce their Scope
        2 emissions and showcase their commitment to tackling climate change.
      </p>
      <ul className="shell_bullets_list">
        <li>
          In different parts of the globe, we offer{" "}
          <strong>
            large-scale and on-site generation, supply and storage.
          </strong>
        </li>
        <li>
          In addition, <strong>Renewable Energy Credits</strong> and other
          innovative emissions products from Shell Energy help customers further
          reduce their carbon footprint.
        </li>
      </ul>
      <p><strong>Netherlands</strong></p>
      <ul className="shell_bullets_list icons_list">
        <li>
          Part of the consortium developing the Borssele 3 and 4 wind farms
          (total installed capacity: 366MW)
        </li>
        <li>
          HKN offshore wind farms (79%) - scheduled for operation in 2023.
          (total of 759 MW capacity)
        </li>
        <li>
          Solar projects for 24 MW total capacity from solar, already active and
          under development
        </li>
      </ul>
    </div>
    <div className="colRight col50 solidColourContainer align-self-start">
      <p>
        Shell has access to <strong>5.6 GW</strong> of operating renewable power
        capacity globally and a sizeable development pipeline.
      </p>
      <p>
        Acquisitions such as <strong>Savion</strong> in the United States will
        add <strong>18 GW</strong> of solar power capacity and battery storage
        currently under development.
      </p>
      <p className="text-center">
        <img
          alt=""
          class="mr-3"
          src="images/renewablePower-solar.png"
          width="auto"
          height="100px"
        />
        <img
          alt=""
          class="ml-3"
          src="images/renewablePower-wind.png"
          width="auto"
          height="100px"
        />
      </p>
    </div>
  </div>,
  <div className="slideContainer slide_solidColour noGutters">
    <div className="colLeft col50 backgroundImage">
      <img
        src="images/renewablePower-investments.jpg"
        width="100%"
        height="auto"
      />
    </div>
    <div className="colRight col50 solidColourContainer stats">
      <p class="statsIntro">Investments</p>
      <p>
        <strong>Up to 49% stakes in large solar</strong> platforms in the US,
        Singapore, Australia and others in the pipeline
      </p>
      <div class="d-flex split2x2">
        <p className="figureContainer">
          <span className="figure">&lt;150</span>
          <br />
          solar farms
        </p>
        <p className="figureContainer">
          <span className="figure">12</span>
          <br />
          markets
        </p>
        <p className="figureContainer">
          <span className="figure">5</span>
          <br />
          continents
        </p>
      </div>
    </div>
  </div>,
  <div className="slideContainer slide_solidColour noGutters">
    <div className="colLeft col50 backgroundImage">
      <img
        src="images/renewablePower-innovation.jpg"
        width="100%"
        height="auto"
      />
    </div>
    <div className="colRight col50 solidColourContainer stats">
      <p class="statsIntro">Innovation</p>
      <p>
        Investment in <strong>offshore incl. floating wind</strong> farms and
        other next-gen technologies
      </p>
      <p className="figureContainer">
        Since
        <br />
        <span className="figure">2001</span>
        <br />
        an offshore & onshore wind player
      </p>
    </div>
  </div>,
  <>
    <h4 className="slideTitle">Shell’s Integrated Energy Landscape</h4>
    <div className="slideContainer slide_solidColour">
      <img
        src="images/renewablePower-intEnergyLandscape.jpg"
        width="100%"
        height="auto"
      />
    </div>
  </>,
  <div className="slideContainer slide_solidColour">
    <div className="colLeft col40">
      <h4 className="slideTitle">Renewable Power via Certificates</h4>
      <p>
        Renewable power is a bundled electricity supply with the renewable
        energy certificate of your choice.
      </p>
      <p>
        We offer a range of simplified, effective retail-delivered renewable
        energy plans that fit your business needs and budget.
      </p>
      <ul className="shell_bullets_list">
        <li>Buy or sell Renewable Energy Certificates (RECs)</li>
        <li>International Renewable Energy Certificates (IRECs)</li>
        <li>Green-e RECs</li>
      </ul>
    </div>
    <div className="colRight col60">
      <img src="images/renewablePower-certificates.JPG" width="100%" height="auto" alt="" />
    </div>
  </div>,
];
